import { List } from "@material-ui/core";
import React, { useMemo } from "react";
import { defaultMeetingModules } from "../../../models/defaultMeetingModules";
import { ModulePlaceholder } from "./ModulePlaceholder";

const isAdmin = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const parsedUser = JSON.parse(user);
    if (parsedUser.admin && parsedUser.admin == true) return true;

    return false;
  }
  return false;
};

export const ModuleList = (props) => {
  const { modules = [], activeModules = [], view, addModule = () => null } = props;
  const moduleList = useMemo(() => {
    if (view == "MyModules") {
      return modules;
    }
    const au = isAdmin();
    if (au) return defaultMeetingModules;
    else
      return defaultMeetingModules.filter((d) => {
        return !d.admin && (typeof d.permission == "undefined" || props.permissions.some((y) => y == d.permission));
      });
  }, [view, props.permissions]);
  return (
    <List
      className="module-list dark-list"
      onDragEnter={(e) => {
        e.dataTransfer.dropEffect = "move";
        e.preventDefault();
      }}
      onDragOver={(e) => {
        e.dataTransfer.dropEffect = "move";
        e.preventDefault();
      }}
      style={{ display: "flex", flexWrap: "wrap" }}
    >
      {moduleList.map((m, i) => {
        let blocked = false;
        if (activeModules.find((am) => am.meetingModuleId == m.meetingModuleId)) blocked = true;
        return (
          <div
            key={i}
            draggable={!blocked}
            style={{
              cursor: !blocked ? "grab" : "default",
              width: "50%",
              height: "auto",
              padding: "2px",
            }}
            onDragStart={(e) => {
              e.dataTransfer.effectAllowed = "copyMove";
            }}
            onDragEnd={(e) => {
              let clientX = e.nativeEvent._ffix_cx ?? e.clientX;
              let clientY = e.nativeEvent._ffix_cy ?? e.clientY;
              let y = ((clientY - 55) / (window.innerHeight - 55)) * 100;
              let x = ((clientX - (320 + 296 / 2)) / (window.innerWidth - 320)) * 100;
              if (e.pageX == 0 && e.pageY == 0 && e.clientX == 0 && e.clientY == 0) {
                x = 0;
                y = 0;
              }
              if (x > -2 && y > -2) {
                addModule(m.name || m.moduleType, m.meetingModuleId || -1000, {
                  x,
                  y,
                });
              }
            }}
          >
            <ModulePlaceholder
              onAdd={() =>
                addModule(m.name || m.moduleType, m.meetingModuleId || -1000, {
                  x: 0,
                  y: 0,
                })
              }
              type={m.name || m.moduleType}
              blocked={blocked}
              module={m}
              created={m.meetingModuleId}
              displayName={m.displayName}
              {...props}
            />
          </div>
        );
      })}
    </List>
  );
};
